import Header from "@/atomic/atoms/Header";
import { InputMask } from "@react-input/mask";
import { PropsView } from "../Models/pin";
import Loading from "@/atomic/atoms/Loading";
import Button from "@/atomic/atoms/Button";

export default function PinView({
  timer,
  handleSubmit,
  pin,
  onChange,
  isLoading,
  error,
  handleTryAgain,
  goBack,
  isDisabled,
}: PropsView) {
  return (
    <div className="h-full relative flex flex-col bg-white overflow-hidden">
      <Header
        title="Validar acesso"
        hasLeftButton
        goBack={goBack}
      />
      <main className="flex-1 w-full flex justify-center min-h-0 bg-background">
        <article className="w-full max-w-[480px] px-6 pt-6 pb-8 flex flex-col flex-1 min-h-0">
          <div className="flex-1 min-h-0 overflow-y-auto pb-4">
            <h2 className="text-text text-[22px] leading-tight font-primary font-semibold tracking-tight">
              Validar PIN
            </h2>
            <p className="text-tertiary text-sm font-primary mt-1">
              Digite o código PIN enviado para o seu celular cadastrado. O tempo de duração é de 15 minutos
            </p>

            <div className="mt-8 flex flex-col items-center">
              <div>
                <InputMask
                  value={pin}
                  onChange={onChange}
                  className={`w-[260px] tracking-[20px] text-text bg-transparent text-center h-7 text-2xl font-primary ${error ? "text-error" : ""}`}
                  type="text"
                  inputMode="numeric"
                  name="pin"
                  placeholder="_____"
                  mask="_____"
                  replacement={{ _: /\d/ }}
                />
                {error && (
                  <div className="flex items-center w-[260px] justify-center mt-2">
                    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" className="shrink-0 mr-1">
                      <circle cx="8" cy="8" r="7" stroke="var(--color-error)" strokeWidth="1.5" />
                      <path d="M8 4.5V9" stroke="var(--color-error)" strokeWidth="1.5" strokeLinecap="round" />
                      <circle cx="8" cy="11.5" r="0.75" fill="var(--color-error)" />
                    </svg>
                    <p className="text-error text-center text-xs font-primary">Pin inválido. Tente novamente.</p>
                  </div>
                )}
              </div>

              <div className="mt-6 text-tertiary text-xs font-primary leading-relaxed">
                <p>Não recebeu o PIN por SMS? Tente estas opções:</p>
                <ul className="list-disc list-inside mt-1 space-y-0.5">
                  <li>Verifique se o número do Pedágio Eletrônico Sem Parar está bloqueado e, se necessário, desbloqueie.</li>
                  <li>Confirme se digitou o número correto.</li>
                  <li>Confira se há sinal da sua operadora.</li>
                  <li>Reinicie o cadastro e tente novamente.</li>
                  <li>Caso necessário, cadastre outro número para receber o PIN.</li>
                </ul>
              </div>

              <button
                type="button"
                className="text-primary mt-6 text-base font-primary font-semibold underline"
                onClick={handleTryAgain}
              >
                Reenviar código {timer !== 0 && "em 00:" + (timer < 10 ? "0" : "") + timer}
              </button>
            </div>
          </div>

          <div className="mt-8 shrink-0">
            <Button
              className="rounded-theme-large bg-primary text-white font-primary font-semibold border-0"
              title="Avançar"
              type="submit"
              onClick={handleSubmit}
              isDisabled={isDisabled}
            />
          </div>
        </article>
      </main>
      {isLoading && <Loading />}
    </div>
  );
}
